<template>
    <div>
        <BaseButton
            class="text-theme-icon"
            dusk="MoreActionsHeader"
            :tooltip="localizations[lang].tooltips.moreActions"
            icon="baseline-more_vert-24px"
            width="24px"
            height="24px"
            aria-haspopup="menu"
            :aria-expanded="isMenuVisible"
            @click="toggleMenu"
        />
        <AdaptiveListDropdown :is-open="isMenuVisible" @close="toggleRightSubmenu">
            <ListItemButton
                v-if="isAudiobook"
                v-tooltip="localizations[lang].tooltips.about"
                dusk="aboutAudiobook"
                icon-name="outline-info-24px"
                width="24px"
                height="24px"
                @click="toggleAudiobookAbout"
            >
                <span>{{ localizations[lang].tooltips.about }}</span>
            </ListItemButton>
            <ReaderPromoteAppButton />
            <ComponentListsButton />
            <BookCitationMenu />
            <SocialShareButton v-if="isShareEnabled" />
            <DebugMenuSection v-if="isDevMode" />
        </AdaptiveListDropdown>
    </div>
</template>

<script>
import ComponentListsButton from './ComponentListsButton.vue';
import AdaptiveListDropdown from './list/AdaptiveListDropdown.vue';
import ReaderPromoteAppButton from '../ReaderPromoteApp/ReaderPromoteAppButton.vue';
import BaseButton from './buttons/BaseButton.vue';
import SocialShareButton from '../SocialShare/SocialShareButton.vue';
import BookCitationMenu from './BookCitationMenu.vue';
import DebugMenuSection from './DebugMenuSection.vue';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import ListItemButton from './list/ListItemButton.vue';

export default {
    components: {
        ListItemButton,
        ReaderPromoteAppButton,
        ComponentListsButton,
        AdaptiveListDropdown,
        SocialShareButton,
        BookCitationMenu,
        BaseButton,
        DebugMenuSection,
    },
    props: {
        isMenuVisible: {
            type: Boolean,
            required: true,
        },
    },
    computed: {
        ...mapState(['ui', 'localizations', 'lang']),
        ...mapGetters(['onlyMobileVisible', 'isShareEnabled', 'isAudiobook']),
        isDevMode() {
            return process.env.VITE_ENV === 'local';
        },
    },
    methods: {
        ...mapMutations(['toggleAudiobookAbout']),
        ...mapActions(['toggleRightSubmenu']),
        toggleMenu() {
            this.$emit('toggle', !this.isMenuVisible);
        },
    },
};
</script>
